const CLIENT_ERROR_STATUS_LIMIT = 500;
const ACCESS_DENIED_STATUSES = [403, 404];
const ACTIVITY_FEED_RETRY_LIMIT = 2;
const TRANSIENT_CLIENT_ERROR_STATUSES = [408, 429];

const getErrorStatus = (error: unknown): number | null => {
  if (!error || typeof error !== 'object' || !('response' in error)) {
    return null;
  }

  const { response } = error;

  if (!response || typeof response !== 'object' || !('status' in response)) {
    return null;
  }

  return typeof response.status === 'number' ? response.status : null;
};

export const isAccessDeniedError = (error: unknown) => {
  const status = getErrorStatus(error);

  return status !== null && ACCESS_DENIED_STATUSES.includes(status);
};

export const shouldRetryActivityFeed = (failureCount: number, error: Error) => {
  const status = getErrorStatus(error);
  const isDeterministicError =
    status !== null &&
    status < CLIENT_ERROR_STATUS_LIMIT &&
    !TRANSIENT_CLIENT_ERROR_STATUSES.includes(status);

  if (isDeterministicError) {
    return false;
  }

  return failureCount < ACTIVITY_FEED_RETRY_LIMIT;
};
